export function isPollAddinAppId(appId: string): boolean {
    const storePollId = "b51e3efb-9c17-4a01-af72-09187d818a57";
    const preinstalledPollId = "afde34e6-58a4-4122-8a52-ef402180a878";
    
    return (appId.toLowerCase() === storePollId.toLowerCase() ||
        appId.toLowerCase() === preinstalledPollId.toLowerCase());
}
